"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable max-len */
var FilterInput = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
      value = _ref.value,
      _onChange = _ref.onChange,
      label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('relative flex items-center text-primary', className)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    ref: ref,
    className: "bg-gray-200 py-1 px-6 rounded outline-none flex-1 border-solid border-transparent border-b-2 focus:border-primary transition-colors duration-300",
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, label), /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Magnifier, {
    className: "absolute fill-gray-500 h-6 w-6"
  }), value && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.resetFilterInput"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "absolute right-0 cursor-pointer",
      title: title,
      onClick: function onClick() {
        return _onChange('');
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.FilterClose, {
      className: "h-6 w-6 fill-primary"
    }));
  }));
});

FilterInput.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  label: _propTypes["default"].node
};

var noop = function noop() {};

FilterInput.defaultProps = {
  value: '',
  className: '',
  onChange: noop,
  label: ''
};
var _default = FilterInput;
exports["default"] = _default;